import { WidgetEventUpdateExchangePayload, WidgetEventUpdatePairPayload } from "@cede/types";
import { create } from "zustand";

type UseTradindViewState = {
  exchange: WidgetEventUpdateExchangePayload | null;
  setExchange: (exchange: WidgetEventUpdateExchangePayload | null) => void;
  pairSymbol: WidgetEventUpdatePairPayload;
  setPairSymbol: (pairSymbol: WidgetEventUpdatePairPayload) => void;
  // Tracks whether the trading widget has been initialized (sent at least one event)
  isWidgetInitialized: boolean;
  reset: () => void;
};

export const useTradingViewStore = create<UseTradindViewState>((set) => ({
  exchange: null,
  setExchange: (exchange) =>
    set({
      exchange,
      isWidgetInitialized: true, // Widget is initialized when it sends exchange data
    }),
  pairSymbol: null,
  setPairSymbol: (pairSymbol) => {
    set({
      pairSymbol,
      isWidgetInitialized: true, // Widget is initialized when it sends pair data
    });
  },
  isWidgetInitialized: false,
  reset: () =>
    set({
      exchange: null,
      pairSymbol: null,
      isWidgetInitialized: false,
    }),
}));
